import React, { useEffect, useState } from 'react'
import { Input, message } from 'antd'
import LocationIcon from '../../assets/images/location.svg'
import SearchIcon from '../../assets/images/search-black.svg'

/**
 * Represents a component for handling location input and autocomplete.
 * @component
 * @param {Object} props - The properties of the component.
 * @param {string} props.location - The current location value.
 * @param {function} props.setLocation - Callback to set the location value.
 * @param {boolean} props.multipleLocations - Indicates if multiple locations are allowed.
 * @param {Array} props.locationList - List of already added locations.
 * @param {function} props.setAbleToAdd - Callback to set the ability to add a location.
 * @param {boolean} props.ableToAdd - Indicates whether it's possible to add a location.
 * @returns {JSX.Element} - The rendered component.
 */
const Location = props => {
  const {
    location,
    setLocation,
    multipleLocations,
    locationList,
    setAbleToAdd,
    ableToAdd,
  } = props
  let autoComplete = null
  let autoComplete1 = null
  const [locationText, setLocationText] = useState()

  useEffect(() => {
    setLocationText(location)
  }, [location])

  /**
   * Initialize the Google Places Autocomplete.
   * If multipleLocations is false, it initializes autoComplete for a single location. Otherwise, it initializes autoComplete1 for the multipleLocations location.
   */
  useEffect(() => {
    /*global google*/
    if (!multipleLocations) {
      autoComplete = new google.maps.places.Autocomplete(document.getElementById('autocomplete'), {
        types: ['(cities)'],
      })
      autoComplete.addListener('place_changed', handlePlaceSelect)
    } else {
      autoComplete1 = new google.maps.places.Autocomplete(document.getElementById('autocomplete1'), {
        types: ['(cities)'],
      })
      autoComplete1.addListener('place_changed', handlePlaceSelect1)
    }
  }, [])

  /**
   * Handles place selection from autocomplete, sets location if valid, and manages ability to add location.
   */
  const handlePlaceSelect = () => {
    const addressObject = autoComplete.getPlace()
    if (addressObject.formatted_address) {
      setLocation && setLocation(addressObject.formatted_address)
      if (setAbleToAdd && ableToAdd && addressObject) {
        setAbleToAdd(true)
      }
    } else {
      message.error('Enter a valid location.')
    }
  }

  /**
   * Handles place selection from second autocomplete instance, updates location and add permission.
   */
  const handlePlaceSelect1 = () => {
    const addressObject = autoComplete1.getPlace()
    if (setAbleToAdd && ableToAdd && addressObject) {
      setAbleToAdd(true)
    }
    setLocation && setLocation(addressObject.formatted_address)
  }

  /**
   * Adds a new location if valid and not already added; shows error otherwise.
   */
  const handleAddLocation = () => {
    if (ableToAdd) {
      if (locationList?.includes(location)) {
        message.error('You have already added this location.')
        return
      }
      setAbleToAdd(false)
    } else {
      message.error('Enter a valid location.')
    }
  }

  return (
    <div className="location-container">
      {!multipleLocations ? (
        <div className="location-input-wrapper">
          <span className="left-icon">
            <img src={LocationIcon} alt="location" />
          </span>
          <Input
            id="autocomplete"
            size="large"
            onChange={e => {
              if (ableToAdd) {
                setAbleToAdd(false)
              }
              setLocationText(e.target.value?.trimStart())
            }}
            placeholder="Enter your city, state"
            value={locationText}
            className=" inputs-box"
            onKeyPress={event => {
              if (event.key === 'Enter') {
                ableToAdd && handleAddLocation()
              }
            }}
          />
          <span className="right-icon">
            <img src={SearchIcon} alt="search" />
          </span>
        </div>
      ) : (
        <Input
          id="autocomplete1"
          onChange={e => {
            setLocation(e.target.value?.trimStart())
            if (ableToAdd) {
              setAbleToAdd(false)
            }
          }}
          placeholder="Location"
          value={locationText}
          className=" inputs-box"
        />
      )}
    </div>
  )
}

export default Location
